// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__8syhL","inner":"Footer_inner__2cGsI"};